import React, { Component } from "react";
import { Button, Card } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { Image, Col, Container, Row } from "react-bootstrap";

import PublicationCard from "./PublicationCard";

class Publications extends Component {
  containerStyle = { paddingTop: 30, paddingBottom: 30 };
  publicationStyle = { paddingTop: 10, paddingBottom: 10 };

  state = {
    publications: this.props.data.publications,
    sortState: { author: false, year: false, title: false },
  };

  handleSortButton = (evt) => {
    let publicationsSorted = [...this.state.publications];
    console.log(evt);

    if (evt === "sort-by-title") {
      publicationsSorted = this.state.sortState.title
        ? publicationsSorted.sort(
            (firstPub, secondPub) =>
              firstPub.Fields.title > secondPub.Fields.title
          )
        : publicationsSorted
            .sort(
              (firstPub, secondPub) =>
                firstPub.Fields.title > secondPub.Fields.title
            )
            .reverse();
      this.setState({
        sortState: {
          ...this.state.sortState,
          title: !this.state.sortState.title,
        },
      });
    }
    if (evt === "sort-by-author") {
      publicationsSorted = this.state.sortState.author
        ? publicationsSorted.sort(
            (firstPub, secondPub) =>
              firstPub.Fields.author > secondPub.Fields.author
          )
        : publicationsSorted
            .sort(
              (firstPub, secondPub) =>
                firstPub.Fields.author > secondPub.Fields.author
            )
            .reverse();
      this.setState({
        sortState: {
          ...this.state.sortState,
          author: !this.state.sortState.author,
        },
      });
    }
    if (evt === "sort-by-year") {
      publicationsSorted.sort((firstPub, secondPub) =>
        this.state.sortState.year
          ? firstPub.Fields.year > secondPub.Fields.year
          : firstPub.Fields.year < secondPub.Fields.year
      );
      this.setState({
        sortState: {
          ...this.state.sortState,
          year: !this.state.sortState.year,
        },
      });
    }

    this.setState({ publications: publicationsSorted });
  };

  render() {
    return (
      <div>
        <DropdownButton id="dropdown-basic-button" title="Sort by...">
          <Dropdown.Item
            onSelect={this.handleSortButton}
            eventKey="sort-by-title"
            href="#/sort-by-title"
          >
            Title
          </Dropdown.Item>
          <Dropdown.Item
            onSelect={this.handleSortButton}
            eventKey="sort-by-author"
            href="#/sort-by-author"
          >
            First author
          </Dropdown.Item>
          <Dropdown.Item
            onSelect={this.handleSortButton}
            eventKey="sort-by-year"
            href="#/sort-by-year"
          >
            Year
          </Dropdown.Item>
        </DropdownButton>

        <Container style={this.containerStyle}>
          {this.state.publications.map((element) => (
            <Row style={this.publicationStyle}>
              <Col xs={12} md={12}>
                <PublicationCard
                  title={element.Fields.title}
                  bodyText={element.Fields.author}
                  buttonText={element.Fields.url}
                  //   TODO: insert url
                  header={element.Fields.year + " " + element.EntryType}
                />
              </Col>
            </Row>
          ))}
        </Container>
      </div>
    );
  }

  renderPublications() {
    this.props.data.publications.forEach((element) => {
      return (
        <Row>
          <Col xs={12} md={12}>
            <PublicationCard
              title={element.title}
              bodyText={element.authors}
              buttonText={element.url}
              featureText={element.category}
            />
          </Col>
        </Row>
      );
    });
  }
}

export default Publications;
